import Vue from 'vue'
import Vuex from 'vuex'
import agency from './modules/agency'
import aid from './modules/aid'
import auth from './modules/auth'
import category from './modules/category'
import event from './modules/event'
import location from './modules/location'
import sector from './modules/sector'
import state from './modules/state'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state: {
    loading: false
  },
  modules: {
    agency,
    aid,
    auth,
    category,
    event,
    location,
    sector,
    state,
    user
  }
})
